import { useState } from "react";
import { FAQS } from "../mock";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 md:py-32 bg-neutral-50">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 reveal">
          <p className="text-xs tracking-[0.25em] uppercase text-neutral-500 mb-4">
            — FAQ
          </p>
          <h2 className="display text-[40px] md:text-[64px] leading-[1.02]">
            Questions?{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Answered</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 md:h-4 bg-[#FFE14D] -z-0 rounded-sm" />
            </span>
            .
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <button
                key={i}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className={`w-full text-left rounded-2xl border transition-colors ${
                  isOpen
                    ? "bg-white border-black"
                    : "bg-white border-black/10 hover:border-black/40"
                }`}
              >
                <div className="flex items-center justify-between p-6">
                  <span className="display text-lg md:text-xl font-bold pr-4">
                    {f.q}
                  </span>
                  <span
                    className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center border transition-colors ${
                      isOpen
                        ? "bg-[#FFE14D] border-black"
                        : "border-black/20"
                    }`}
                  >
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </div>
                <div
                  className={`grid transition-[grid-template-rows] duration-500 ease-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-neutral-600 text-[15px] leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
